module.exports = __webpack_public_path__ + "static/media/comment1_1.ff30f577.png";